import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { defineMessages, FormattedMessage } from 'react-intl';

import List from '../../components/List';
import { contactShape, getContactDetails } from './util';
import ContactNotes from './contact-notes';

import './styles.css';

const messages = defineMessages({
  back: {
    id: 'repvisits.contacts.selected.back',
    defaultMessage: '« Back',
  },
});

class SelectedContact extends React.PureComponent {
  static propTypes = {
    contact: contactShape.isRequired,
    dismiss: PropTypes.func.isRequired,
    changeRepVisitsContactNotes: PropTypes.func.isRequired,
  };

  render() {
    let contactDetails;
    const { contact, changeRepVisitsContactNotes, dismiss } = this.props;
    const schoolName = get(contact, 'highSchool.name') || '';
    const active = !!schoolName;
    if (active) {
      contactDetails = getContactDetails(contact);
    }
    return (
      <div className="visible-mobile-block hidden-tablet hidden-computer" styleName={`selected-contact${active ? ' active' : ''}`}>
        <div styleName="overflow">
          <button type="button" styleName="back-link" onClick={dismiss}><FormattedMessage {...messages.back} /></button>
          {active && (
          <List divided relaxed>
            <List.Item>
              <div styleName="person">
                <div styleName="avatar" aria-hidden="true">
                  {contactDetails.avatar ?
                    <img src={contactDetails.avatar} alt={contactDetails.fullName} /> :
                    <div styleName="initials">{contactDetails.initials}</div>}
                </div>
                <div styleName="info">
                  <div styleName="name">{contactDetails.fullName}</div>
                  <div styleName="title">{contactDetails.position}</div>
                </div>
              </div>
            </List.Item>
            <List.Item styleName="data">
              <div styleName="school-name">
                {schoolName}
              </div>
              <div styleName="address">
                {contactDetails.address}
              </div>
            </List.Item>
            <List.Item styleName="data">
              <span styleName="phone">{contactDetails.phone}</span>
            </List.Item>
            <List.Item styleName="data">
              <div styleName="mail">
                {contactDetails.mail}
              </div>
            </List.Item>
            <List.Item styleName="data">
              <ContactNotes
                notes={contactDetails.notes}
                changeRepVisitsContactNotes={changeRepVisitsContactNotes}
                contact={contact}
              />
            </List.Item>
          </List>
          )}
        </div>
      </div>
    );
  }
}

export default SelectedContact;
